export default __webpack_public_path__ + "static/media/carousel-isp-mdu-03.05f44e14.png";